import { useContext, useEffect } from "react";
import styled from "styled-components";
import I1 from "./img/instruction-1.PNG";
import I2 from "./img/instruction-2.PNG";
import IFinal from "./img/final.PNG";
import Executable from "./img/exe.PNG";
import Cloud from "./img/cloud_download_120dp_5084C1.png";
import { ApiConnectWelcomeBackSession } from "../../api/LionsUserApiConect";
import UserNotLogged from "../Dashboard/DashboardItems/UserNotLogged";
import { PageContext } from "../../Context/PageContext";
import { TipMouseOutEvent, TipMouseOverEvent } from "../../Tooltip/Tooltip";


function Downloads() {

    const {setPage} = useContext(PageContext);

    useEffect(() => {

        let result = ApiConnectWelcomeBackSession();
                result.then((response) => {

                    if(response.status == 403 || response.status == 401) {
                            setPage(<UserNotLogged />);
                            return;
                        } else {
                            setTimeout(() => {
                            document.getElementById('RankingsMaster').style.opacity = "1";
                            }, 300);
                        }
                })
            
        },[]);

    return(
        <RankingsContainer id='RankingsMaster'>
            <TitleContainer>
                <Title>Download e Instalação</Title>
                <T1>
                    <p>
                    Siga os passos abaixo para poder instalar o Cliente Lions Rag e se logar no nosso servidor.<br/><br/>
                    Nosso servidor utilizar um "Autopatcher" para atualizar automáticamente o cliente quando implementarmos novos episódeos e novidades. </p>
                </T1>
            </TitleContainer>

            <InstructionsMasterContainer>
                <InstrunctionContainer>
                    <InstructionTitle>Passo 1</InstructionTitle>
                    <InstructionImage img={Executable} width={"50px"} height={"50px"}/>

                    <InstructionDescription>
                        <br/>Baixe o Cliente LionsRag e após terminar o download, extraia no local de sua preferência.</InstructionDescription>

                    <a href="http://www.lionsragnarokserver.net/downloads/LionsRagnarok.zip">
                    <CloudImage
                        img={Cloud}
                        width={"100px"} height={"100px"}
                        onMouseOver={(event) => TipMouseOverEvent(event, "Clique para baixar", "rgba(55, 128, 217, 1)")} onMouseLeave={() => TipMouseOutEvent()}
                    /></a>

                    <ClienteTag>Cliente LionsRagnarok (7.06GB)</ClienteTag>
                </InstrunctionContainer>

                <InstrunctionContainer>
                    <InstructionTitle>Passo 2</InstructionTitle>
                    <InstructionImage img={Executable} width={"50px"} height={"50px"}/>
                    <InstructionDescription><br/>Após extrair, abra a pasta <b>"LionsRagnarok"</b>, 
                     procure pelo aplicativo <b>"Cliente Lions Ragnarok"</b>, 
                     clique com o botão direito e clique em <b>"Propriedades"</b></InstructionDescription>
                    <InstructionImage img={I1} width={"320px"} height={"414px"} />
                </InstrunctionContainer>

                <InstrunctionContainer>
                    <InstructionTitle>Passo 3</InstructionTitle>
                    <InstructionImage img={Executable} width={"50px"} height={"50px"}/>
                    <InstructionDescription><br/>Clique na aba <b>"Compatibilidade"</b>, marque a caixa <b>"Executar este programa como administrador"</b>. Clique em <b>"OK"</b>.<br/>
                    Pronto! Seu cliente já está configurado para funcionar corretamente.<br/><br/>
                    Crie um atalho do Executável na sua area de trabalho
                    </InstructionDescription>
                    
                    <InstructionImage img={I2} width={"320px"} height={"414px"}/>
                </InstrunctionContainer>
            </InstructionsMasterContainer>

            <InstructionsMasterContainer>
                <InstrunctionContainer>
                    <FinalImage img={IFinal} width={"560px"} height={"400px"}/>
                </InstrunctionContainer>
            </InstructionsMasterContainer>

        </RankingsContainer>
             )
}

export default Downloads;

const RankingsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    transition: 2s;
    margin-bottom: 50px;
    opacity: 0;
    //border: solid;

    @media (max-width: 1000px) {
    width: 90vw;
    margin-top: 30px;
    }

`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1280px;

    @media (max-width: 1000px) {
    width: 90%;
    //text-align: justify;
    margin-bottom: 50px;
    }
`;

const Title = styled.h1`
    font-size: 30pt;

    @media (max-width: 1000px) {
    font-size: 28pt;
    text-align: center;
    }
`;

const T1 = styled.div`
    width: 1000px;
    padding: 10px 20px;
    //border: solid;
    text-align: center;
    font-size: 13pt;


    @media (max-width: 1000px) {
    width: 100%;
    overflow: auto;
    padding: 10px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    font-size: 11pt;
    }

`;

const InstructionsMasterContainer = styled.div`
    display: flex;
    align-items: start;
    justifify-content: center;
    margin-bottom: 50px;

    @media (max-width: 1000px) {
    width: 90vw;
    flex-direction: column;
    }
`;

const InstrunctionContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 40px;
    align-items: center;
    height: 700px;
   //border: solid;
   //justify-content: space-between;
`;

const InstructionTitle = styled.h1`
    font-size: 30pt;

    @media (max-width: 1000px) {
    font-size: 28pt;
    text-align: center;
    //border: solid;
    }
`;

const ClienteTag = styled.h2`
    font-size: 15pt;
    margin: 0px 0 0px 0;
    transition: .2s ease-in-out;
`

const CloudImage = styled.div`
    background-image: url('${props => props.img}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: ${props => props.width};
    height: ${props => props.height};
    margin: 0px 0 0 0;
    //scale: .5;
    transition: .2s ease-in-out;
    //box-shadow: 0 0 5px 0 black;
    border-radius: 10px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover{
    scale: 1.3;
    }

    @media (max-width: 1000px) {
        scale: 1;

        &:hover{
            scale: 1.3;
        }
    }
    
    
`;

const InstructionDescription = styled.span`
    font-size: 12pt;
    width: 300px;
    margin-bottom: 30px;

    @media (max-width: 1000px) {
    text-align: center;
    }
`;

const InstructionImage = styled.div`
    background-image: url('${props => props.img}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: ${props => props.width};
    height: ${props => props.height};
    margin: 0 0 0 0;
    //scale: .5;
    transition: .2s ease-in-out;
    box-shadow: 0 0 5px 0 black;
    border-radius: 10px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover{
    scale: 1.5;
    }

    @media (max-width: 1000px) {
        scale: 1;

        &:hover{
            scale: 1.3;
        }
    }
    
`;


const FinalImage = styled.div`
    background-image: url('${props => props.img}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: ${props => props.width};
    height: ${props => props.height};
    margin: 0 0px 0 0;
    //scale: .5;
    transition: .2s ease-in-out;
    box-shadow: 0 0 5px 0 black;
    border-radius: 10px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover{
    scale: 1.5;
    }

    @media (max-width: 1000px) {
        width: 300px;
        height: 200px;
        scale: 1;

        &:hover{
            scale: 1.3;
        }
    }
    
    
`;




